import { usePathname, useSearchParams } from 'next/navigation';
import { SyntheticEvent, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { LeftCaretIcon } from '@components/Icons';

import { useFeatureFlags } from '@config';

import { primaryPages, SCREENS } from '@constants';

import { Button } from '../../Button';

interface BackButtonProps {
  text?: string;
  onClick?: (event: SyntheticEvent) => void;
  href?: string;
}

const languageNamespace = 'common';

export const BackButton = ({ text, onClick, href }: BackButtonProps) => {
  const { rolloutBackButtonVisibility } = useFeatureFlags();
  const { t } = useTranslation(languageNamespace);
  const searchParams = useSearchParams();
  const pathname = usePathname();

  const showBackButton = useMemo(() => {
    const isPrimaryPage = primaryPages.includes(pathname as SCREENS);
    const notNavigatedFromMenu = searchParams?.get('notNavigatedFromMenu') ?? false;
    const navigatedFromCT = searchParams?.get('navigatedFromCT') ?? false;
    return (
      (!navigatedFromCT && (!isPrimaryPage || notNavigatedFromMenu)) || !rolloutBackButtonVisibility
    );
  }, [pathname, searchParams, rolloutBackButtonVisibility]);

  return (
    showBackButton && (
      <Button
        text={text ?? t('back')}
        appearance="text"
        icon={() => <LeftCaretIcon size={10} />}
        useStrokeForIcon={true}
        onClick={onClick}
        href={href}
      />
    )
  );
};
